// extracted by mini-css-extract-plugin
module.exports = {"textStyle":"Career_textStyle__2iX6h","boxStyle":"Career_boxStyle__3qYbb","backgroundStyle":"Career_backgroundStyle__3M792"};